<template>
  <div>
    <div class="tw-text-md tw-mb-4 tw-font-medium">
      {{ $t("calendarPermissions.title") }}
    </div>

    <div class="tw-mb-8 tw-ml-4 tw-flex tw-flex-col tw-gap-4">
      <div class="tw-flex tw-gap-2 tw-text-sm">
        <v-img
          src="@/assets/gcal_logo.png"
          class="tw-flex-none"
          height="20"
          width="20"
        />
        <div>{{ $t("calendarPermissions.viewEvents") }}</div>
      </div>
      <div class="tw-flex tw-gap-2 tw-text-sm">
        <v-img
          src="@/assets/gcal_logo.png"
          class="tw-flex-none"
          height="20"
          width="20"
        />
        <div>{{ $t("calendarPermissions.seeList") }}</div>
      </div>
    </div>

    <div class="tw-text-md tw-mb-4 tw-font-medium">
      {{ $t("calendarPermissions.theseWill") }}
    </div>
    <div
      class="tw-mb-8 tw-flex tw-flex-col tw-gap-4 tw-text-sm tw-text-very-dark-gray"
    >
      <div>{{ $t("calendarPermissions.displayNames") }}</div>
      <div>
        {{ $t("calendarPermissions.displayAll") }}
      </div>
    </div>

    <div class="tw-flex">
      <!-- <v-spacer /> -->
      <v-btn v-if="cancelLabel != ''" @click="$emit('cancel')" text class="tw-mr-2 tw-flex-1">
        {{ cancelLabel ?? $t("common.cancel") }}
      </v-btn>
      <v-btn @click="$emit('allow')" class="tw-flex-1 tw-bg-green" dark>
        {{ allowLabel ?? $t("calendarPermissions.allow") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "CalendarPermissionsCard",

  props: {
    cancelLabel: { type: String, default: null },
    allowLabel: { type: String, default: null },
  },
}
</script>
